export default {
    path: "/promotion",
    name: "promotion",
    redirect: "/promotion",
    component: () => import("@/layouts/base/index.vue"),
    meta: { title: "营销" },
    children: [
        {
            path: "/promotion",
            name: "promotionManage",
            meta: { title: "营销概览" },
            component: () => import("@/views/promotion/manage/List.vue")
        },
        {
            path: "",
            name: "promotionOverview",
            meta: { title: "营销管理" },
            children: [
                {
                    path: "coupon/list",
                    name: "couponManage",
                    meta: { title: "优惠券" },
                    component: () => import("@/views/promotion/coupon/List.vue")
                },
                {
                    path: "seckill/list",
                    name: "seckillManage",
                    meta: { title: "限时秒杀" },
                    component: () => import("@/views/promotion/seckill/List.vue")
                },
                {
                    path: "full-reduction/list",
                    name: "fullReductionManage",
                    meta: { title: "满减活动" },
                    component: () => import("@/views/promotion/productActivity/fullReduction/List.vue")
                },
                {
                    path: "reward-gift/list",
                    name: "rewardGiftManage",
                    meta: { title: "满赠活动" },
                    component: () => import("@/views/promotion/productActivity/rewardGift/List.vue")
                },
                {
                    path: "limitdiscount-gift/list",
                    name: "limitdiscountManage",
                    meta: { title: "限时折扣" },
                    component: () => import("@/views/promotion/productActivity/limitdiscount/List.vue")
                },
                {
                    path: "product-gift/list",
                    name: "productGift",
                    meta: { title: "活动赠品" },
                    component: () => import("@/views/promotion/productGift/List.vue")
                },
                {
                    path: "e-card/list",
                    name: "eCardManage",
                    meta: { title: "电子卡券" },
                    component: () => import("@/views/promotion/eCard/List.vue")
                }
            ]
        }
    ]
};
